import { getTutorSchedule } from '@/app/actions/bookings';
import { callAction } from '@/lib/call-action';

type ScheduleResult = Awaited<ReturnType<typeof getTutorSchedule>>;

const inFlight = new Map<string, Promise<ScheduleResult>>();

export function requestSchedule(
  tutorUsername: string,
  bundleId: string,
  timezone: string,
  excludedClassId?: string
): Promise<ScheduleResult> {
  const key = `${tutorUsername}|${bundleId}|${timezone}|${excludedClassId ?? ''}`;
  const pending = inFlight.get(key);
  if (pending) return pending;

  const request = callAction(() =>
    getTutorSchedule(tutorUsername, bundleId, 30, excludedClassId, timezone)
  ).finally(() => inFlight.delete(key));
  inFlight.set(key, request);
  return request;
}
